import {useEffect, useState} from "react";
import {MedicalOrganization} from "../../../types/MedicalOrganization";
import {getMedicalOrganizations} from "../../../services/medicalOrganization";

export const useMedicalOrganizations = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [medicalOrganizations, setMedicalOrganizations] = useState<MedicalOrganization[]>([]);

  const fetch = async () => {
    setIsLoading(true);
    const tempMedicalOrganizations = await getMedicalOrganizations();
    setIsLoading(false);
    setMedicalOrganizations(tempMedicalOrganizations as MedicalOrganization[]);
  }

  useEffect(() => {
    fetch()
  }, []);

  return { isLoading, medicalOrganizations }
}